/**
 * @generated SignedSource<<1605126a58e2f28264ff54ab81f5cfc8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime'
import { FragmentRefs } from 'relay-runtime'
export type PostStructuredData_post$data = {
  readonly slug: string
  readonly h1: string
  readonly image: {
    readonly url: string
  } | null
  readonly meta_description: string | null
  readonly published_at: string | null
  readonly modified_at: string
  readonly ' $fragmentType': 'PostStructuredData_post'
}
export type PostStructuredData_post$key = {
  readonly ' $data'?: PostStructuredData_post$data
  readonly ' $fragmentSpreads': FragmentRefs<'PostStructuredData_post'>
}

const node: ReaderFragment = {
  argumentDefinitions: [],
  kind: 'Fragment',
  metadata: null,
  name: 'PostStructuredData_post',
  selections: [
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'slug',
      storageKey: null
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'h1',
      storageKey: null
    },
    {
      alias: null,
      args: null,
      concreteType: 'PostImage',
      kind: 'LinkedField',
      name: 'image',
      plural: false,
      selections: [
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'url',
          storageKey: null
        }
      ],
      storageKey: null
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'meta_description',
      storageKey: null
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'published_at',
      storageKey: null
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'modified_at',
      storageKey: null
    }
  ],
  type: 'Post',
  abstractKey: null
}

;(node as any).hash = 'ad501cbfb69821deb7852836a9e40ef6'

export default node
